import { useCallback, useEffect, useState } from "react";
import { SubscriptionData } from "../api/useWebSockets";
import { removeHtmlTagsAndEntities } from "../utils/removeHtmlTagsAndEntities";
import { getNotificationTypeLabel } from "../utils/getNotificationTypeLabel";
import logo from "../../public/neuroimprove_fav.png";


const frontEndUrl = process.env.NODE_ENV === "development" ? "http://localhost:5173" : "https://crm.neuroimprove.pt";

export const useNotificationsHandler = () => {
    const [permission, setPermission] = useState("Notification" in window ? Notification.permission : null);

    useEffect(() => {
        if ("Notification" in window && Notification.permission === "default") {
            Notification.requestPermission().then((perm) => {
                setPermission(perm);
            });
        }
    }, []);

    const showBrowserNotification = useCallback(
        (notification: { id: string; content: string; type: string; navigationPath: string; userName: string }) => {
            if (permission !== "granted") return;

            try {
                const typeLabel = getNotificationTypeLabel(notification.type);

                const browserNotification = new Notification(`Nova ${typeLabel}! 🔔`, {
                    body: `${notification.userName}\n${removeHtmlTagsAndEntities(notification.content).slice(0, 100)}`,
                    icon: logo,
                    requireInteraction: false,
                    silent: false,
                    tag: `notification-${notification.id}`,
                });

                browserNotification.onclick = () => {
                    window.open(`${frontEndUrl}${notification.navigationPath}`, "_blank");
                    browserNotification.close();
                };
            } catch (error) {
                // Silent fail for browser notification
            }
        },
        [permission]
    );

    const handleNotificationEvent = useCallback(
        (subscriptionData: SubscriptionData) => {
            const { event, data } = subscriptionData;
         

            if (event === "create" && data && Array.isArray(data)) {
                data.forEach((notification: any) => {
                    const userName = notification.user_that_generated_notification
                        ? `${notification.user_that_generated_notification.first_name} ${notification.user_that_generated_notification.last_name}`
                        : "Alguém";

                    showBrowserNotification({
                        id: notification.id?.toString() || "",
                        content: notification.content || "",
                        type: notification.type || "",
                        navigationPath: notification.navigation_path || "",
                        userName,
                    });
                });
            }
        },
        [showBrowserNotification]
    );

    return { handleNotificationEvent };
};
